<template>
  <div class="online-container">
    <img
      src="../assets/images/onlineshowheaderbg.png"
      style="width: 100%; height: 350px"
    />
    <div class="container">
      <p class="online-title">
        HOT PRODUCTS <span style="color: #619a37">热门</span>单品
      </p>
      <div class="line"></div>
      <div class="row-between" style="padding: 0 0 30px 0">
        <div class="row">
          <div class="row online-sort">
            <el-radio-group
              fill="#619A37"
              text-color=""
              style="margin-right: 20px"
              v-model="sorter.field"
              size="mini"
              @change="handleParamChange"
            >
              <el-radio-button
                v-for="sort in sorters"
                :label="sort.value"
                :key="sort.value"
                >{{ sort.lable }}</el-radio-button
              >
            </el-radio-group>
          </div>
        </div>
        <div class="row-between">
          <p class="online-sort-title">{{ $t("Products Category") }}：</p>
          <el-select
            style="width: 200px; margin-right: 43px"
            v-model="filters.categoryId"
            placeholder="请选择"
            clearable
            @change="handleParamChange"
            @clear="filters.categoryId = null"
          >
            <el-option
              v-for="item in categories"
              :key="item.id"
              :label="$i18n.locale == 'zh' ? `${item.name}` : `${item.nameEn}`"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <p class="online-sort-title">{{ $t("Hall") }}：</p>
          <el-select
            style="width: 200px"
            v-model="filters.venueId"
            placeholder="请选择"
            clearable
            @change="handleParamChange"
            @clear="filters.venueId = null"
          >
            <el-option
              v-for="item in venues"
              :key="item.id"
              :label="
                $i18n.locale == 'zh'
                  ? `${item.number} ${item.name}`
                  : `${item.number} ${item.nameEn}`
              "
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div>
        <div class="online-list">
          <div
            v-for="(item, idx) in entities"
            :key="idx"
            class="online-item column-between"
            @click="handleExhibitClick(item)"
          >
            <div class="online-item-top">
              <div
                class="online-item-img row-center"
                style="position: relative"
              >
                <img
                  class="online-icon-recom"
                  :src="
                    item.properties.albums[0] ||
                      require('../assets/images/bike.png')
                    /*'../assets/images/image_onlinedemo.png'*/
                  "
                />
                <img
                  v-if="item.hot"
                  style="
                    position: absolute;
                    right: 11px;
                    top: 11px;
                    width: 50px;
                    height: 38px;
                  "
                  src="../assets/images/icon_hot_right.png"
                />
              </div>
              <p class="online-item-name">
                {{ $i18n.locale == "zh" ? item.name : item.nameEn }}
              </p>
            </div>
            <p class="online-item-comp">
              {{
                $i18n.locale == "zh" ? item.exhibitorName : item.exhibitorNameEn
              }}
            </p>
          </div>
        </div>
        <el-pagination
          style="text-align: center; padding-bottom: 30px"
          background
          layout="prev, pager, next"
          :current-page="pagination.current"
          :page-size.sync="pagination.pageSize"
          :total="pagination.total"
          @current-change="handlePageChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import CategoryService from "../services/category";
import ExhibitService from "../services/exhibit";
import VenueService from "../services/venue";
import { getHotExhibitPage, getHotExhibits3 } from "../http/api";

export default {
  components: {},
  data() {
    return {
      // 排序
      sorters: [
        {
          lable: this.$t("Default"),
          value: "sequence desc"
        },
        {
          lable: this.$t("Latest"),
          value: "create_time desc"
        }
      ],
      // 分类
      categories: [],
      // 展馆
      venues: [],
      // 数据服务
      service: ExhibitService,
      // 初始参数绑定
      entity: {
        hot: true,
        enabled: true,
        approved: true,
        approveResult: "APPROVED"
      },
      // 查询参数绑定
      filters: {
        venueId: null,
        categoryId: null
      },
      // 查询排序参数绑定
      sorter: {
        field: "sequence asc",
        order: "DESC"
      },
      // 页面数据
      entities: [],
      // 分页参数
      pagination: {
        current: 1,
        pageSize: 12,
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      }
    };
  },
  computed: {
    ...mapGetters({
      hasCollected: "hasCollected",
      hasLiked: "hasLiked"
    })
  },
  methods: {
    ...mapActions({
      addCollected: "addCollected",
      deleteCollected: "deleteCollected",
      addLiked: "addLiked",
      deleteLiked: "deleteLiked"
    }),
    handleCheckedCitiesChange(value) {},
    handleExhibitClick(exhibit) {
      this.$router.push(`/exhibit/${exhibit.id}`);
    },
    handleParamChange() {
      this.pagination.current = 1;
      this.getEntityPage(
        this.entity,
        this.pagination,
        this.filters,
        this.sorter
      );
    },
    handlePageChange(page) {
      this.pagination.current = page;
      this.getEntityPage(
        this.entity,
        this.pagination,
        this.filters,
        this.sorter
      );
    },
    async getVenues() {
      const result = await VenueService.getEntities();
      this.venues = result;
    },
    async getCategories() {
      const result = await CategoryService.getEntities();
      this.categories = result.toTree();
    },
    async getEntityPage(entity, pagination, filters, sorter) {
      if (filters) {
        for (const key in filters) {
          const param = filters[key];
          entity[key] = param;
        }
      }

      const pageable = {
        page: pagination.current - 1,
        size: pagination.pageSize,
        isUp: true
      };

      if (sorter) {
        pageable.sort = sorter.field;
      }
      const result = await getHotExhibitPage({
        ...filters,
        ...pageable,
        hot: true
      });
      this.entities = result.content;
      this.pagination.current = result.number + 1;
      this.pagination.total = result.totalElements;
    }
  },
  mounted() {
    this.getCategories();
    this.getVenues();
    this.getEntityPage(this.entity, this.pagination, this.filters, this.sorter);
  }
};
</script>
<style lang="less" scoped>
.online-container {
  background: #eaeaea;
  .container {
    width: 1200px;
    margin: 0 auto;
  }
}

.online-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  // justify-content: space-between;
}
.online-item:hover .online-item-comp {
  background: #619a37;
  color: #ffffff;
}
.online-item:nth-child(4n) {
  margin-right: unset;
}
.online-item {
  width: 277px;
  height: 372px;
  margin-right: 30px;
  background: #fff;
  margin-bottom: 30px;
  cursor: pointer;
  .online-item-top {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    .online-item-img {
      width: 278px;
      height: 272px;
      display: flex;
      align-items: center;
      justify-content: center;
      .online-icon-recom {
        max-width: 100%;
        max-height: 100%;
      }
    }
    .online-item-name {
      width: 100%;
      font-size: 14px;
      font-family: FZLanTingHeiS-DB1-GBK;
      font-weight: 400;
      color: #444444;
      text-align: center;
      padding: 18px 0;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .online-item-comp {
    width: 100%;
    font-size: 14px;
    font-family: FZLanTingHeiS-DB1-GBK;
    font-weight: 400;
    color: #999999;
    height: 46px;
    width: 100%;
    text-align: center;
    line-height: 46px;
    border-top: 1px solid #dddddd;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.online-sort-title {
  font-size: 14px;
  font-family: FZLanTingHeiS-DB1-GBK;
  font-weight: 400;
  color: #444444;
}
.online-header-list {
  display: flex;
  flex-direction: row;
  width: 628px;
  height: 399px;
  margin-top: 40px;
  flex-wrap: wrap;
  .online-header-item {
    width: 157px;
    height: 133px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #333333;
    cursor: pointer;
    .online-header-img {
      width: 157px;
      height: 100px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      img {
        height: 56px;
      }
    }
    .online-header-text {
      font-size: 14px;
      font-family: FZLanTingHeiS-DB1-GBK;
      font-weight: 400;
      color: #ffffff;
    }
  }
}
.online-header-item:hover {
  background: #619a37;
}
/deep/ .online-swiper .el-carousel__container {
  height: 399px !important;
  width: 572px;
}
.online-header-swiper {
  margin-top: 40px;
  background: #ffffff;
}
.online-siper-detail {
  padding: 100px 15px 30px 15px;
  height: 100%;
  box-sizing: border-box;
  .online-siper-name {
    font-size: 14px;
    font-family: FZLanTingHeiS-DB1-GBK;
    font-weight: 400;
    color: #444444;
  }
  .online-siper-comp {
    font-size: 14px;
    font-family: FZLanTingHeiS-DB1-GBK;
    font-weight: 400;
    color: #999999;
    margin-top: 16px;
    margin-bottom: 14px;
  }
  .online-siper-btnlist {
    p {
      width: 58px;
      height: 30px;
      background: #619a37;
      border-radius: 2px;
      line-height: 30px;
      text-align: center;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      margin-right: 4px;
    }
  }
  .online-swiper-line {
    width: 100px;
    height: 1px;
    background: #999999;
    margin: 20px 0;
  }
  .online-siper-desc {
    font-size: 12px;
    font-family: FZLanTingHeiS-DB1-GBK;
    font-weight: 400;
    color: #666666;
  }
}
.online-header-left {
  height: 100%;
  .online-header-tag {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    .online-icon-recom {
      width: 101px;
      height: 101px;
    }
    .online-icon-new {
      width: 50px;
      height: 38px;
      margin-top: 20px;
    }
  }
  .online-swiper-img {
    margin: -8px 0 0 10px;
  }
}
.online-title {
  font-size: 20px;
  font-family: Poppins;
  font-weight: bold;
  color: #444444;
  padding: 37px 0 7px;
}
.line {
  width: 30px;
  height: 2px;
  background: #619a37;
  margin-bottom: 27px;
}

/deep/ .el-select {
  .el-input__inner {
    height: 30px !important;
    line-height: 30px;
  }
  .el-input__prefix,
  .el-input__suffix {
    top: 6px;
  }
}

//::v-deep(.el-input__inner) {
//  height: 30px !important;
//}
</style>



// WEBPACK FOOTER //
// src/view/hotlist.vue